<div class="email-confirmation-container">
  <h1 class="mat-headline-medium">
    @switch (status) {
      @case ('loading') {
        <span>Ativando sua conta</span>
      }
      @case ('success') {
        <span>Sua conta está ativada</span>
      }
      @case ('error') {
        <span>Houve um erro ao ativar a conta</span>
      }
    }
  </h1>

  <div class="status-visual">
    @switch (status) {
      @case ('loading') {
        <mat-spinner diameter="64"></mat-spinner>
      }
      @case ('success') {
        <mat-icon
          class="material-symbols-outlined status-icon success-icon"
          aria-hidden="true"
        >
          check_circle
        </mat-icon>
      }
      @case ('error') {
        <mat-icon
          class="material-symbols-outlined status-icon error-icon"
          color="warn"
          aria-hidden="true"
        >
          x_circle
        </mat-icon>
      }
    }
  </div>

  @if (status === 'error') {
    <p class="mat-body-large error-subtitle">
      Verifique o link acessado e a conta logada
    </p>
  }
</div>
